<template>
  <div class="c-marked-text">
    <div
      class="c-marked-text__content markdown-body"
      :class="{ 'markdown-body_justify': justify }"
      v-html="sanitizedText ?? ''"
    ></div>
  </div>
</template>

<script setup lang="ts">
  import { marked } from 'marked';
  import DOMPurify from 'dompurify';
  import { computed, ref, watch } from 'vue';

  const props = defineProps<{
    text?: string | null;
    justify?: boolean;
  }>();

  const markedText = ref<string | null>(null);

  const sanitizedText = computed(() =>
    markedText.value ? DOMPurify.sanitize(markedText.value) : null
  );

  watch(
    () => props.text,
    async text => {
      markedText.value = text ? await marked.parse(text) : null;
    },
    {
      immediate: true
    }
  );
</script>

<style>
  .markdown-body {
    p {
      font-size: 16px;
    }

    p:first-child {
      margin-top: 0;
    }

    p:last-child {
      margin-bottom: 0;
    }

    h4 {
      font-size: 24px;
      margin: 0;
    }

    &__text {
      font-size: 16px;
    }

    &_justify {
      text-align: justify;

      p {
        text-align: justify;
      }

      ol {
        p {
          /* text-align: left; */
        }
      }
    }
  }
</style>
